<dialog #dialog class="w-40">
  <div class="modal-header">
    <span style="display: block!important; text-align: center; width: 100%">Pobierz aplikacje</span>
  </div>
  <div class="modal-content mb-4">
   <div class="d-flex justify-content-center">
     <a href="https://play.google.com/store/apps/details?id=com.aspello.eMieszkaniec&hl=pl">
       <span class="sr-only">Przejdź do sklepu Google Play</span>
       <img class="d-block" style="width: 100%; padding-left: 1.5rem; padding-right: 1.5rem" src="/img/get_in_google_play.png" alt="Pobierz z sklepu Google Play">
     </a>
   </div>
    <strong class="d-flex justify-content-center mb-3">
      LUB
    </strong>
    <div class="d-flex justify-content-center">
      <a class="d-flex justify-content-center" href="https://play.google.com/store/apps/details?id=com.aspello.eMieszkaniec&hl=pl">
        <span class="sr-only">Przejdź do sklepu App Store</span>
        <img class="d-block" style="width: 86%" src="/img/get_in_app_store.png" alt="Pobierz z sklepu Apple App Store">
      </a>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="dialog.close()" type="button" class="btn btn-primary">
      Zamknij
    </button>
  </div>
</dialog>
